<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.licensing" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				<a [routerLink]="['/' + ac.urls.licensing]">Key Search</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">
				Offline License Search
			</li>
		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
		</div>
	</div>
</div>

<button (click)="ut.scrollToSpot('top-of-list')" id="top-of-list-button" class="cp-scroll-to-top-end d-none" title="Go to top">
	<fa-icon [icon]="['fas', 'angle-up']"></fa-icon>Top
</button>
<div class="list-wrapper" id="list-page-id" (scroll)="ut.onDivScrollHandler('top-of-list-button', 'list-page-id')">
	<div id="top-of-list"></div>

	<div [ngStyle]="{'display': formMode === 'searchForm' ? '' : 'none' }">
		<form [formGroup]="theSearchForm">
			<div class="row ps-2 pe-2">
				<div class="cp-filter-block-4">
					<ng-select [items]="ac.searchableKeyTypesSelections" bindValue="value" bindLabel="label" id="typesFilter"
						formControlName="typesFilter" [multiple]="true" placeholder="Type(s)" placement="bottom"
						ngbTooltip="Filter results by one or more license type">
					</ng-select>
				</div>

				<div class="cp-filter-block-4">
					<ng-select [items]="productsSelections" bindValue="value" bindLabel="label" id="productsFilter"
						formControlName="productsFilter" [multiple]="true" placeholder="Product(s)" placement="bottom"
						ngbTooltip="Filter results by one or more license product">
					</ng-select>
				</div>

				<div class="cp-filter-block-4">
					<ng-select [items]="ac.specialOfflineSearches" bindValue="value" bindLabel="label" id="specialFilter"
						formControlName="specialFilter" [multiple]="true" placeholder="Specialized Filter(s)" placement="bottom"
						ngbTooltip="Special filters/search parameters">
					</ng-select>
				</div>

				<div class="cp-filter-block-4">
					<input type="search" id="hostidFilter" formControlName="hostidFilter" class="form-control"
						placeholder="Host ID(s)/IP(s)" placement="bottom"
						ngbTooltip="Enter one or more (space separated) host IDs and/or host IPs" />
				</div>

				<div class="cp-filter-block-4">
					<input type="search" id="textFilter" formControlName="textFilter" class="form-control"
						placeholder="Text - Customer/Notes" placement="bottom"
						ngbTooltip="Text to search for in Customer and notes fields" />
				</div>

				<div class="cp-filter-block-4">
					<ng-select [items]="lpusers" bindValue="id" bindLabel="email" id="userIDs" formControlName="userIDs" [multiple]="true"
						placeholder="Last touched by..." placement="bottom"
						ngbTooltip="Last user from legacy license portal to either add or update this license">
					</ng-select>
				</div>
			</div>

			<div *ngIf="searching" style="text-align: center;">
				<app-loading-spinner></app-loading-spinner>
			</div>

			<div class="form-group text-center" *ngIf="!searching">
				<button class="btn btn-primary" type="button" (click)="doSearch()">
					<fa-icon [icon]="['fas', 'search']"></fa-icon> Search for Offline Licenses
				</button>
				<button *ngIf="showResetButton" class="btn btn-outline-primary ms-1" type="button" (click)="resetForm()">
					Reset Search Parameters
				</button>
			</div>
		</form>
		<div *ngIf="showNoParamsMessage" class="cp-warning-message mt-4">You must supply at least one search parameter
		</div>

		<!-- stretches panel down enough so that autocomplete popups have space -->
		<div *ngIf="!showResults" style="height:300px"></div>
	</div>

	<!-- <div *ngIf="showRecentMessage" class="cp-info-message mt-4">Recently Viewed Keys</div> -->
	<div [ngStyle]="{'display': !showResults ? 'none' : '' }">

		<div *ngIf="showResults" class="container mt-2">
			<div class="row mb-2">
				<div class="col-12 p-0 text-center align-middle">
					<span class="fw-bold large border p-2">
						<span *ngIf="!items || items.length === 0" class="text-warning">
							No Offline Licenses Found
						</span>
						<span *ngIf="items && items.length === 1">
							One Offline License Found
						</span>
						<span *ngIf="items && items.length > 0 && maxMessage === ''">
							{{ items.length }} Offline Licenses Found
						</span>
						<span *ngIf="items && items.length > 0 && maxMessage !== ''" class="text-warning">
							{{ maxMessage }}
						</span>
					</span>
				</div>
			</div>
		</div>

		<app-paging-search-bar [parentApi]="getParentMethod()"></app-paging-search-bar>

		<table *ngIf="!searching && itemsToShow.length > 0" class="cp-std-table cp-auto-width mx-auto">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
			</thead>

			<tbody *ngIf="itemsToShow && !searching">
				<tr *ngFor="let item of itemsToShow">
					<td class="text-nowrap" [attr.data-order]="tt.formatDateTimeUTC(item.created_at)">
						{{ item.created_at | date: ac.tableDateFmt }}
					</td>
					<td>
						{{ item.customer }}
					</td>
					<td [title]="item.type">
						{{ item.type | titlecase }}
					</td>
					<td class="text-nowrap">
						{{ item['__niceProduct'] }}
					</td>
					<td class="text-nowrap cp-key">
						<a [routerLink]="['/'+ ac.urls.licensing, 'hostid', item.hostid]" [ngbPopover]="popupContent"
							popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
							{{ item.hostid }}
						</a>
					</td>
					<td class="text-nowrap" [attr.data-order]="tt.formatDateTimeUTC(item.expires_at)">
						{{ item.expires_at | date: ac.tableDateFmt }}
					</td>
					<td class="text-nowrap">
						<span *ngIf="item.user_id && item.user_id !== 0">
							{{ item['__lastTouched'] | titlecase }}
						</span>
					</td>

					<ng-template #popupContent>
						<app-card-license [object]="item"></app-card-license>

						<!-- <div class="cp-popover-banner">{{ item.hostid }}</div>
						<div class="cp-pre-text">{{ popOverTools.getLicensePopoverLines(item).join('\n')}}</div> -->
					</ng-template>
				</tr>
			</tbody>
		</table>
		<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"></app-paging-bar>
	</div>
</div>